import Tipsy from 'tippy.js'

class Tooltip {
  constructor(element) {
    this.tooltipTrigger = element
    this.theme = element.dataset.theme || 'tippy-tooltip--dept'
    this.placement = element.dataset.placement || 'top' // top(-start, -end), right(-start, -end), bottom(-start, -end), left(-start, -end)
    this.maxWidth = element.dataset.maxWidth || '350px'

    this.init()
  }

  init() {
    this.instance = new Tipsy(this.tooltipTrigger, {
      placement: this.placement,
      maxWidth: this.maxWidth,
      interactive: true,
      arrow: true,
      theme: this.theme,
      zIndex: 555, // match with tooltip.scss
      content(reference) {
        const { id, label } = reference.dataset

        if (id) {
          const container = document.createElement('div')
          const linkedTemplate = document.getElementById(id)
          const node = document.importNode(linkedTemplate.content, true)
          container.appendChild(node)
          return container
        }

        return label || 'Tooltip could not be loaded...'
      },
    })
  }
}

export default Tooltip
